import * as React from 'react';
import { Column } from "react-table";
import Table from "../../components/table/Table";
import { CLIENT_ROUTE, API_ROUTE, CLIENT_TITLE } from "./constants";
import TableIndicator from "../../components/common/TableStatus";
import dayjs from "dayjs";
import Page from "../../components/layout/Page";
import { useListPage } from "../../hooks";
import RowActions from "../../components/table/RowActions";
import CreateButton from "../../components/common/CreateButton";
import type { IArticle } from "./types";

interface IArticleRecord extends Pick<IArticle, '_id' | 'createdAt' | 'createdUserName' | 'isDeleted' | 'isPublished' | 'publishedAt' | 'readCount' | 'title'> {
    actions: unknown;
}

const ArticleList = () => {

    const { records, paginationState, deleteRecord, handleInteraction } = useListPage<IArticleRecord>({
        apiRoute: API_ROUTE,
        clientRoute: CLIENT_ROUTE
    });

    const columns: Column<IArticleRecord>[] =  [
        {
            Header: 'Гарчиг',
            accessor: 'title',
        },
        {
            Header: 'Уншсан тоо',
            accessor: 'readCount',
        },
        {
            Header: 'Нийтэлсэн хэрэглэгч',
            accessor: 'createdUserName',
        },
        {
            Header: 'Төлөв',
            accessor: 'isPublished',
            Cell: ({ value }) => {
                return <TableIndicator active={value}/>;
            },
            width: 1
        },
        {
            Header: 'Үүсгэсэн огноо',
            accessor: 'createdAt',
            Cell: (table) => {
                const value = table.row.original.createdAt;
                const date = dayjs(value).format('YYYY-MM-DD HH:ss:mm')
                return (
                    <div>
                        {date}
                    </div>
                )
            }
        },
        {
            Header: '',
            accessor: 'actions',
            Cell: (table) => {
                return (
                    <RowActions id={table.row.original._id} clientRoute={CLIENT_ROUTE} deleteRecord={deleteRecord}/>
                )
            }
        },
    ];

    return (
        <Page>
            <Page.Header title={CLIENT_TITLE}>
                <CreateButton route={CLIENT_ROUTE}/>
            </Page.Header>
            <Page.Body>
                <Table
                    searchable
                    columns={columns}
                    data={records}
                    totalPages={paginationState.totalPage}
                    onInteraction={handleInteraction}
                />
            </Page.Body>
        </Page>
    )
};

export default ArticleList;